// Overlay design tokens (originally derived from web glassTokens; maintained independently)

export const palette = {
  onyx: '#121216',
  brilliantRose: '#FF3FAF',
  coralGlow: '#FF865C',
  bananaCream: '#FFE768',
} as const;

export const brandGradient = {
  horizontal: 'linear-gradient(90deg, #FFE768 0%, #FF865C 50%, #FF3FAF 100%)',
} as const;

export const glass = {
  surfaceHeavy: 'rgba(18,18,22,0.92)',
  card: 'rgba(18,18,22,0.85)',
  timer: 'rgba(18,18,22,0.80)',
  /** Opaque badge background for OBS browser sources — avoids per-card backdrop-filter compositor layers. */
  surfaceBadgeSolid: 'rgba(18,18,22,0.85)',
} as const;

export const glassBorder = {
  subtle: 'rgba(255,255,255,0.06)',
  light: 'rgba(255,255,255,0.08)',
  medium: 'rgba(255,255,255,0.18)',
  strong: 'rgba(255, 255, 255, 0.35)',
} as const;

// CD directive: all overlay text must be white (white is the floor; accent colours are fine as
// emphasis). secondary/muted/disabled are raised to #FFFFFF so every consumer reads white
// regardless of which semantic token name it reaches for. Token names are kept intact so
// all existing call sites continue to compile without changes.
export const glassText = {
  primary: '#F1F5F9',
  secondary: '#FFFFFF',
  muted: '#FFFFFF',
  disabled: '#FFFFFF',
} as const;

export const semantic = {
  warning: '#FDBD0D',
  error: '#DC2626',
} as const;

/**
 * Typography family tokens — import `fonts` and use the named keys instead of
 * raw font-family strings. This is the single source of truth for the overlay's
 * two-font system (Fjalla One display + Source Sans 3 body).
 *
 * Direction C: Fjalla One (display) + Source Sans 3 (UI/body/data).
 * Both fonts are self-hosted via @fontsource for broadcast reliability — no CDN
 * flash or failure mid-stream. Fonts are imported in src/main.tsx.
 */
export const fonts = {
  /** Display: condensed, high-impact. Reserve for SHORT, large, prominent strings only
   *  (player names, panel/section titles, hero text). Never body copy. */
  display: "'Fjalla One', system-ui, -apple-system, sans-serif",
  /** UI / data / body — the workhorse for everything else. */
  body: "'Source Sans 3', system-ui, -apple-system, sans-serif",
  /** Monospace — code/path/connection strings only. */
  mono: "'SF Mono', Consolas, 'Courier New', monospace",
} as const;
